export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_AUTHENTICATE = 'AUTH_AUTHENTICATE';
export const AUTH_GET_ME = 'AUTH_GET_ME'
export const AUTH_CANCEL_SUBSCRIPTION = 'AUTH_CANCEL_SUBSCRIPTION'